import GenericViewMixin from '@/mixins/GenericViewMixin'

import metrics from '@/collections/metrics'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    loaderMetric: false,
    metrics: metrics
  }),
  methods: {
    getMetric (name) {
      const i = this.metrics.findIndex(m => m.name === name)
      if (!i && i !== 0) {
        return null
      }
      return this.metrics[i]
    }
  }
}